import crudActions from '../../crud/actions'

const actions = crudActions('SERVICEUSER_INFORMATION_')

export default actions
